import clsx from 'clsx';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullPage?: boolean;
}

const sizeStyles = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export function LoadingSpinner({ size = 'md', className, fullPage }: LoadingSpinnerProps) {
  const spinner = (
    <Loader2 className={clsx('animate-spin text-accent', sizeStyles[size], className)} />
  );

  if (fullPage) {
    return (
      <div className="flex h-full min-h-[400px] items-center justify-center">{spinner}</div>
    );
  }

  return spinner;
}
